<template>
<div class="edit-area">
  <div class="container-base fullscreen"
    v-show="!previewDialogVisible">
    <h1>
      <router-link :to="{name: 'yagiofferDetail', params: {formatId: formatId}}">{{ currentFormat.title }}</router-link>
    </h1>
    <div class="overflow-scroll-x step"
      ref="step">
      <ol>
        <li v-for="(item, index) in currentFormat.cards"
          :ref="'steps'"
          :key="item.id"
          :index="index"
          :class="{current:(item.id == currentCardId),
                     over:(index < currentCardIndex)}"
          v-ripple>
          <a href="#"
             @click="goCardTo(item.id);$event.preventDefault()">
            {{ item.title }}
          </a>
        </li>
      </ol>
    </div>
    <v-touch v-bind:enabled="{swipe:true, press:false, pan:false, tap:false, rotate:false, pinch:false}"
      v-on:swipeleft="swipeNextCard"
      v-on:swiperight="swipePrevCard"
      v-bind:swipe-options="{direction:'horizontal'}">
      <div class="cards" style="max-width: 100%;"
        v-show="currentCardId">  

        <component v-bind:is="basicInfo"
          ref="editBasic"
          :basic-data="basicData"
          :requiredBasicFields="requiredBasicFields"
          :current-card-id="currentCardId"></component>

        <component v-bind:is="currentFormat.components.edit"
          ref="editFormat"
          :basic-data="basicData"
          :format-id="formatId"
          :preview-format="$refs.previewFormat"
          :example-sentences="exampleSentences"
          :current-card-id="currentCardId"></component>

        <div id="preview-viewer"
          v-show="currentCardId == 'confirm'"
          class="preview-viewer tab-content"
          :style="previewViewerCss"
          ref="previewViewer">
          <component v-bind:is="currentFormat.components.preview"
            ref="previewConfirmFormat"
            :id-prefix="''"
            :format-data="formatData"
            :format-id="formatId"
            :basic-data="basicData"
            :preview-scale="previewScale"
            :current-card-id="currentCardId"></component>
        </div>
        <p v-show="currentCardId == 'confirm'" style="text-align: center;">修正する場合は、プレビューの修正欄をクリックまたはステップを戻ることで修正することができます</p>
        <div class="edit-form-item" style="text-align:center;margin-top: 20px;"
          v-show="currentCardId == 'confirm'" v-if="$site.appFlag!='b' || true">
          <div class="item-body">
            <a id="send-adtop-pdf" type="success" 
              v-if="$firebase.isAuthenticated && getMode != 'production1' && !fontPaymented"
              style="background-color:#0F9934;border-color:#0F9934;"
              @click="$eventHub.$emit('open-fontpayment-dialog', formatId);"
              ><img src="/static/renew_img/bnr/fontbnr20230518_001.png" class="fontbuybnr"/></a>
          </div>
        </div>
        <div class="card-pager-nav">
          <div class="pager">
            <el-button v-ripple
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              v-if="cardId != 'job-history'"
              type="primary">
              次へ <i class="el-icon-d-arrow-right"></i>
            </el-button>
            <el-button v-ripple
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              v-else
              type="primary">
              登録する <i class="el-icon-d-arrow-right"></i>
            </el-button>

            <el-button v-ripple
              v-if="cardId != 'complete'"
              icon="el-icon-d-arrow-left"
              @click="goPrevCard"
              :type="isNextCardAvailable ? 'text': 'primary'"
              :disabled="!isPrevCardAvailable">
              前へ
            </el-button>
          </div>
        </div>

        <div class="text-right">
          <div class="save-time-message"
            v-show="saveNotifyMessage"
            v-if="$yagi.profile.autoSaveEnabled">
            <span>最終保存：</span> <span v-html="saveNotifyMessage"></span>
          </div>
          <div v-else>
            <el-button @click="$eventHub.$emit('open-account-dialog')"
              type="text">ブラウザに自動保存: オフ</el-button>
          </div>
        </div>
        <div class="card-preview-button" v-if="(formatId == 'rirekisho_job_new' || 
        formatId == 'rirekisho_job_new_single' || 
        formatId == 'internship' || 
        formatId == 'rerekisho_part_time')">
          <a href="https://www.yagish.jp/service/daigakuyagish/" target="_blank" style="background-color:#fff;border-color:#fff;color:#FFF"
          ><img src="/static/renew2_img/bnr/univ_bnr_20230621.png" style="width:50%" ></a>
        </div>
        <div class="card-preview-button" v-if="formatId == 'rirekisho_job_new'">
          <el-button v-ripple
            plain
            @click="openIntroduction"
            type="success"
            style="background-color:#fff;border-color:#fff;color:#FFF"
            id="preview-button-format-edit"><img src="/static/renew_img/bnr/intro_bnr_20220926.png" style="width:50%" ></el-button><br><br>
        </div>
      </div>
    </v-touch>
  </div>

  <div class="preview-dialog"
    :style="previewDialogStyleObject"
    ref="previewDialog">
    <div class="preview-action">
      <div class="container-base">
        <ul>
          <li id="close-preview-button-above">
            <el-button class="button-block"
              @click="closePreview"
              type="success"
              id="buckt-to-edit-button-format-edit"
              v-ripple><i class="el-icon-d-arrow-left"></i> 入力画面に戻る</el-button>
          </li>
        </ul>
      </div>
    </div>
    <div class="blog-widghet">
      <div class="blog-widghet-inner success">
        <ul class="blog-widghet-list">
          <li>
            <a class="blog-entry-link">
              <div class="left"></div>
              <div class="right">
                <div class="title">【注意！】印刷・ダウンロード前に、レイアウト崩れがないかご確認ください。</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="preview-tabs">

      <input id="user-viewer-tab"
             type="radio"
             name="preview-tab-active"
             v-model="previewTabActive"
             value="previewFormat">
      <label class="tab-item"
             for="user-viewer-tab">プレビュー</label>

      <input id="example-viewer-tab"
             type="radio"
             name="preview-tab-active"
             v-model="previewTabActive"
             value="sampleFormat">
      <label class="tab-item"
             for="example-viewer-tab">記入例</label>

      <div id="preview-viewer"
        v-show="previewTabActive == 'previewFormat'"
        class="preview-viewer tab-content"
        :style="previewViewerCss"
        ref="previewViewer">
        <component v-bind:is="currentFormat.components.preview"
          ref="previewFormat"
          :id-prefix="''"
          :format-data="formatData"
          :format-id="formatId"
          :basic-data="basicData"
          :preview-scale="previewScale"
          :current-card-id="currentCardId"></component>
      </div>

      <div v-if="sampleData && previewTabActive == 'sampleFormat'"
        id="sample-viewer"
        class="sample-viewer tab-content"
        :style="previewViewerCss"
        ref="sampleViewer">
        <component v-bind:is="currentFormat.components.preview"
          ref="sampleFormat"
          :id-prefix="'sample-'"
          :is-sample="true"
          :format-id="formatId"
          :format-data="sampleData.formatData"
          :basic-data="sampleData.basicData"
          :preview-scale="previewScale"
          :current-card-id="null"></component>
      </div>
    </div>

    <div class="preview-action">
      <div class="container-base">
        <ul>
          <li v-if="$firebase.isAuthenticated">
            <el-button id="pdf-download-preview"
              class="button-block"
              type="primary"
              v-ripple
              @click="$eventHub.$emit('download-tap');"><i class="el-icon-download"></i> メール送信やPDFダウンロードはこちら</el-button>
          </li>
          <li v-if="$firebase.isAuthenticated">
            <el-button id="pdf-eprint-preview"
              class="button-block"
              type="success"
              :disabled="!$deviceLib.isOnline"
              v-ripple
              @click="$eventHub.$emit('open-eprint-dialog', formatId, $refs.previewFormat, formatData.selFontStyle4DB)"><i class="el-icon-printer"></i> コンビニで印刷する</el-button>
          </li>
          <li>
            <el-button class="button-block"
              @click="closePreview"
              type="success"
              v-ripple><i class="el-icon-d-arrow-left"></i> 入力画面に戻る</el-button>
          </li>
        </ul>
      </div>
    </div>

  </div>
  <div class="container-base"
    v-if="!preview">
    <div class="footer-yagi">
      <your-yagi :your-yagi-class="{}"
        :yagi-options="{dialogEnabled:true, rubyEnabled:true, messageEnabled:true}"></your-yagi>
    </div>
  </div>

  <div v-if="isDevelopment">
    <input type="button"
           @click="devAreaVisible =! devAreaVisible"
           value="debug">
    <div v-if="devAreaVisible"
      style="background:#fff;padding:20px;">
      <el-button @click="downloadPDFWithForm">downloadPDFWithForm</el-button>
      <el-button @click="downloadPDF">downloadPDF</el-button>
      <el-button @click="setPreviewHtml">サーバー側HTML</el-button>

      <el-button @click="openSCREENSHOT">Open SCREENSHOT</el-button>
      <el-button @click="mailPDF"
        :disabled="this.mailPDFSending">PDFをメールで送信</el-button>
      <el-button @click="loadPdfBlob">PDFプレビュー</el-button>
      <iframe v-if="pdfBlob" :src="pdfBlob" width="400px" height="600px"></iframe>
      <object v-if="pdfBlob" :data="pdfBlob" type="application/pdf" width="400px" height="600px"></object>
      <pre>{{ dumpData() }}</pre>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<style scoped>
.fontbuybnr{
 width: 50%;
}

@media screen and (max-width: 480px) {
  .fontbuybnr{
  width: 100%;
  }
}
</style>
<script>
import basicInfo from '@/components/BasicInfo'
import timeAgo from '@/assets/lib/time-ago-jp'
import _ from '@/assets/lib/my-lodash'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'
// 書式1枚の高さ
const DOC_PAPER_WIDTH_PX = 794

const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'format_letter',
  'basicData',
  'recentEdit'
]

export default {
  props: {
    formatId: {
      type: String
    },
    preview: {
      type: Boolean,
      default: false
    },
    cardId: {
      type: String
    }
  },
  data: function () {
    return {
      formatData: {},
      otherFormatData: {},
      formatInfo: {},
      basicData: {},
      basicInfo: basicInfo,
      requiredBasicFields: [],
      currentCardId: '',
      fontPaymented:false,
      previewHtml: '',
      previewDialogVisible: true,
      previewScale: 1,
      previewViewerCss: {},
      previewTabActive: 'previewFormat',
      mailPDFSending: false,
      saveNotifyMessage: '',
      saveNotifyMessageUpdateTimer: null,
      saveDate: null,
      devAreaVisible: false,
      currentFormat: {},
      downloadPdfEnabled: true,
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      joblistKeyword2030719: ['建設', 'ゲーム', 'エンジニア', '制作', 'コンサルタント', 'デザイナー', '清掃', '営業', '建築', '事務', '受付', '企画', 'マーケティング', '財務', '会計', '総務', '人事', '法務', '広報', '販売', '物流', '運転士', '金融', '整体師', '農業', '消防士', '警察官', '公務員', '役所', 'NPO', 'ドライバー'],
      joblistKeyword: ['経理', 'フォークリフト', 'ホテル', 'ブライダル', '旅行', '事務', '管理', 'データ入力', '食品', '工場', '軽作業', '倉庫作業', 'IT', '不動産', 'サポート', '美容', '理容', 'エステ', '学校法人', '販売', '接客', 'サービス', 'クリニック', '農業', '農林水産', '製造', '開発', 'デザイナー', 'UX', 'UI', '会計', '役所', '翻訳', '通訳', '編集', '法律事務所', '物流', '受付', '営業', 'コールセンター', 'WEB', 'インターネット', '人事', '化粧品', 'マーケティング', 'ゲーム', '総務', 'エンジニア', 'SE', 'PM', 'マネージャー', 'マネジメント', '建築', '土木', '映像', '建設', '工事', 'アパレル', 'インテリア', '企画', '海運', 'コスメ', '制作', '運営', '設計', 'NPO', '法務', '校正', '金融', '広告', '印刷', '芸能', '映画', '公務員', '公共施設', 'イベント', 'レジャー', 'スポーツ', '整体師', 'コンサルタント', '電気主任技術者', '清掃', '職人', '商社', '財務', '広報', '運転士', 'ものづくり', '消防士', '警察官', '生産管理', '飲食', 'フード', '警備', '点検', '配送', '交通', 'ドライバー', '機械', '医薬', '素材', '化学', 'クリエイティブ', '士業', '医師', 'コメディカル', '保育', '教員', '講師', '介護', '福祉', '動物'],
      pdfBlob: null,
      joblistPrefs: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '海外']
    }
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      this.updatePreviewHTML()
      const formData = new FormData()
      // console.error(this.basicData)
      // console.error(this.basicData.lastName)
      let _data = this.cleanedPreviewHtml.replace("\u0000", "")
      // console.error(_data)
      // console.error(this.cleanedPreviewHtml)
      // formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('app_html', _data)
      formData.append('pdf_option', 'A4')
      // formData.append('pdf_option', 'A4ShowPageNumberFooter')
      return formData
    },
    previewDialogStyleObject: function () {
      if (this.previewDialogVisible) {
        return {
          visibility: 'visible',
          height: 'auto'
        }
      } else {
        return {
          visibility: 'hidden',
          overflow: 'hidden',
          height: 0
        }
      }
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    },
    sampleData: function () {
      if (this.currentFormat.sampleData) {
        return this.currentFormat.sampleData
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    exampleSentences: function () {
      if (this.currentFormat.exampleSentences) {
        return this.currentFormat.exampleSentences
      }
      return {}
    },
    fisrtCardId: function () {
      return this.currentFormat.cards[0].id
    },
    isNextCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex + 1 < this.currentFormat.cards.length
    },
    isPrevCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex > 0
    },
    currentCardIndex: function () {
      if (!this.currentCardId) return -1
      let key, card
      for (key in this.currentFormat.cards) {
        card = this.currentFormat.cards[key]
        if (this.currentCardId === card.id) {
          return Number(key)
        }
      }
      return -1
    },
    currentCardTitle: function () {
      if (!this.currentCardId) return ''
      return this.currentFormat.cards[this.currentCardIndex].title
    },
    currentCardPreviewJumpId: function () {
      if (!this.currentCardId) return ''
      return this.currentFormat.cards[this.currentCardIndex].previewJumpId
    },
    nextCardLabel: function () {
      if (this.isNextCardAvailable) {
        return this.currentFormat.cards[this.currentCardIndex + 1].title
      }
      return ''
    },
    prevCardLabel: function () {
      if (this.isPrevCardAvailable) {
        return this.currentFormat.cards[this.currentCardIndex - 1].title
      }
      return ''
    }
  },
  methods: {
    preventNav(e) {
      // alert(123)
      // if (!this.$firebase.isAuthenticated) {
      //   e.preventDefault()
      //   e.returnValue = ''
      //   this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
      // }
    },
    loadCurrentFormat: function () {
      const result = this.$site.getFormatById(this.formatId)
      if (result) {
        this.currentFormat = result
      } else {
        console.error('result not found:', this.formatId, result)
      }
    },
    dumpData: function () {
      return JSON.stringify({
        'basicData': this.basicData,
        'formatData': this.formatData
      }, null, 2)
    },
    previewScrollTo: function (id) {
      if (!id) {
        return
      }
      this.$nextTick(function () {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'center'
          })
        }
      })
    },
    openIntroduction: function () {
      this.$eventHub.$emit('open-introduction-dialog', this.formatId, this.$refs.previewFormat)
    },
    showTempdata: function () {
      this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
    },
    showPreviewTest: function () {
      console.error('showPreviewTest')
      if (!this.fontPaymented) {
        this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
      }
      this.setPreviewScale()
      this.$nextTick(function () {
        // this.previewScrollTo(this.currentCardPreviewJumpId)
        this.$refs.previewConfirmFormat.checkValid()
      })
    },
    showPreview: function () {
      console.error('showPreview')
      if (!this.fontPaymented) {
        this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
      }
      this.previewDialogVisible = true
      this.previewTabActive = 'previewFormat'
      this.setPreviewScale()
      this.$router.push({
        name: 'formatPreview',
        params: {
          formatId: this.formatId,
          cardId: this.cardId
        }
      })
      this.$nextTick(function () {
        this.previewScrollTo(this.currentCardPreviewJumpId)
      })
      const app = this
      this.$iterateStorage(function (value, key, iterationNumber) {
          if (key === 'basicData') {
            app.username = value.lastName + '' + value.firstName
            for (const label_name in app.fontOptions) {
              // app.fontOptions[label_name].label = app.username + 'さんの履歴書（' + app.fontNames[label_name].label + '）'
              app.fontOptions[label_name].label = '履歴書フォント（' + app.fontNames[label_name].label + '）'
            }
          }
      }, function (err) {})
      this.$eventHub.$emit('show-preview-from-card', this.currentCardPreviewJumpId)
    },
    showPreview4Conv: function () {
      this.$eventHub.$emit('open-eprint-dialog', this.formatId, this.$refs.previewFormat, this.formatData.selFontStyle4DB)
      // this.previewDialogVisible = true
      // this.previewTabActive = 'previewFormat'
      // this.setPreviewScale()
      // this.$router.push({
      //   name: 'formatPreview',
      //   params: {
      //     formatId: this.formatId,
      //     cardId: this.cardId
      //   }
      // })
      // this.getQrcode()
      // this.$nextTick(function () {
      //   this.previewScrollTo(this.currentCardPreviewJumpId)
      // })
      // this.$eventHub.$emit('show-preview-from-card', this.currentCardPreviewJumpId)
    },
    closePreview: function () {
      this.previewDialogVisible = false
      if (this.cardId) {
        this.$router.push({
          name: 'yagiofferEditCard',
          params: {
            formatId: this.formatId,
            cardId: this.cardId
          }
        })
      }
    },
    setRecentEdit: function (data) {
      if (!data) {
        data = {
          timestamp: new Date().getTime(),
          FormatId: this.formatId,
          FormatTitle: this.currentFormat.title,
          cardId: this.currentCardId,
          cardTitle: this.currentCardTitle
        }
      }
      this.$setItem(RECENT_EDIT_SAVE_KEY, data)
      this.$eventHub.$emit('change-recent-edit', data)
    },
    setPreviewScale: function () {
      let viewerRef = this.$refs.previewViewer
      this.$nextTick(function () {
        if (!viewerRef) return
        if (this.previewTabActive === 'sampleFormat') {
          const clientWidth = this.$refs[this.previewTabActive].$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        } else {
          const clientWidth = this.$refs.previewViewer.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      if (!this.$refs[this.previewTabActive]) {
        console.log('!this.$refs[this.previewTabActive]', this.$refs[this.previewTabActive])
        return
      }
      if (!this.$refs[this.previewTabActive].$refs.previewMain) {
        console.log('!this.$refs[this.previewTabActive].$refs.previewMain', this.$refs[this.previewTabActive].$refs.previewMain)
        return
      }
      const height = this.$refs[this.previewTabActive].$refs.previewMain.getBoundingClientRect().height
      if (!height) {
        return
      }
      this.previewViewerCss = {
        height: height + 30 + 'px'
      }
    },
    cardIdExists: function (cardId) {
      for (const key in this.currentFormat.cards) {
        if (this.currentFormat.cards[key].id === cardId) {
          return true
        }
      }
      return false
    },
    goFirstCard: function () {
      this.$router.replace({
        name: 'yagiofferEditCard',
        params: {
          formatId: this.currentFormat.id,
          cardId: this.fisrtCardId
        }
      })
    },
    goCurrentCard: function () {
      console.error("goCurrentCard")
      this.setPreviewScale()
      this.previewDialogVisible = false
      this.$router.push({
        name: 'yagiofferEditCard',
        params: {
          formatId: this.currentFormat.id,
          cardId: this.currentCardId
        }
      })
      console.error(this.formatData)
      this.setRecentEdit()
      this.$eventHub.$emit('deactivate-history-item')
      this.$eventHub.$emit('card-changed', this.currentCardId)
      this.$nextTick(function () {
        this.showPreviewTest()
      })
    },
    scrollToCurrentStep: function () {
      this.$nextTick(function () {
        if (this.currentCardIndex < 0) {
          return
        }
        this.$refs.steps[this.currentCardIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center'
        })
      })
    },
    goCardTo: function (cardId) {
      if (!this.cardIdExists(cardId)) {
        this.goFirstCard()
        return
      }

      if (this.currentCardId == 'requests' && cardId == 'create-date' && this.getMode != 'production') {
        if (this.formatData.registYagioffer && this.formatId == 'rirekisho_job_new') {
          if (this.formatData.registYagioffer) {
            let msg = ''
            if (!this.formatData.department)  {
              msg = msg + '[学部・学科]'
            }
            if (!this.formatData.hopeAreaPref)  {
              msg = msg + '[希望勤務地]'
            }
            if (!this.formatData.hopeIndustry)  {
              msg = msg + '[希望業界]'
            }
            if (!this.formatData.hopeJobcategory)  {
              msg = msg + '[希望職種]'
            }
            if (msg) {
              this.$alert('ヤギオファー登録のため、' + msg + 'を選択してください', '入力エラー', {
                confirmButtonText: 'OK',
                type: 'warning',
                callback: action => {
                }
              })
              return

            }

          }
          // const app = this
          // const formData = new FormData()
          // formData.append('uuid', this.$firebase.user.uid)
          // formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
          // formData.append('version', '2')
          // formData.append('reqflg', '2')

          // formData.append('hope_area_pref', this.formatData.hopeAreaPref)
          // formData.append('hope_industry', this.formatData.hopeIndustry)
          // formData.append('department', this.formatData.department)
          // formData.append('hope_jobcategory', this.formatData.hopeJobcategory)
          // formData.append('graduation_year', this.formatData.gradeYear)

          // this.$axios
          //   .post(this.$varuna.endPoints.registYagiofferMember, formData, {timeout: 60000})
        }
      }

      this.currentCardId = cardId
      this.goCurrentCard()
      this.scrollToCurrentStep()
      if (!this.$firebase.isAuthenticated) {
        if (this.currentCardId == 'address' || this.currentCardId == 'license-history' ) {
          // this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
        }
      }
    },
    goNextCard: function () {
      if (this.isNextCardAvailable) {

        if (this.currentFormat.cards[this.currentCardIndex + 1].id == 'create-date' && this.getMode != 'production') {
          if (this.formatData.registYagioffer && this.formatId == 'rirekisho_job_new') {
            if (this.formatData.registYagioffer) {
              let msg = ''
              if (!this.formatData.department)  {
                msg = msg + '[学部・学科]'
              }
              if (!this.formatData.hopeAreaPref)  {
                msg = msg + '[希望勤務地]'
              }
              if (!this.formatData.hopeIndustry)  {
                msg = msg + '[希望業界]'
              }
              if (!this.formatData.hopeJobcategory)  {
                msg = msg + '[希望職種]'
              }
              if (msg) {
                this.$alert('ヤギオファー登録のため、' + msg + 'を選択してください', '入力エラー', {
                  confirmButtonText: 'OK',
                  type: 'warning',
                  callback: action => {
                  }
                })
                return

              }

            }
            // const app = this
            // const formData = new FormData()
            // formData.append('uuid', this.$firebase.user.uid)
            // formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
            // formData.append('version', '2')
            // formData.append('reqflg', '2')

            // formData.append('hope_area_pref', this.formatData.hopeAreaPref)
            // formData.append('hope_industry', this.formatData.hopeIndustry)
            // formData.append('department', this.formatData.department)
            // formData.append('hope_jobcategory', this.formatData.hopeJobcategory)
            // formData.append('graduation_year', this.formatData.gradeYear)

            // this.$axios
            //   .post(this.$varuna.endPoints.registYagiofferMember, formData, {timeout: 60000})
          }
        }

        this.currentCardId = this.currentFormat.cards[this.currentCardIndex + 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
        if (!this.$firebase.isAuthenticated) {
          if (this.currentCardId == 'address' || this.currentCardId == 'license-history' || this.currentCardId == 'output') {
            this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
          }
        }
      }
    },
    goPrevCard: function () {
      if (this.isPrevCardAvailable) {
        this.currentCardId = this.currentFormat.cards[this.currentCardIndex - 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    goDownloadCard: function () {
      this.goCardTo('output')
    },
    swipeNextCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goNextCard()
      }
    },
    swipePrevCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goPrevCard()
      }
    },
    updateFormatData: function (data) {
      this.formatData = data
      this.downloadPdfEnabled = true
    },
    updateFormatOtherData: function (data) {
      console.error(data)
      this.otherFormatData = data
    },
    updateBasicData: function (data) {
      this.basicData = data
      this.downloadPdfEnabled = true
    },
    saveNotify: function () {
      const now = new Date()
      this.$setItem(LAST_SAVE_DATE_SAVE_KEY, now)
      this.saveDate = now
      this.updateSaveNotifyMessage()
    },
    updateSaveNotifyMessage: function () {
      if (this.saveDate) {
        this.saveNotifyMessage = timeAgo(this.saveDate)
      } else {
        this.saveNotifyMessage = ''
      }
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.currentFormat.id}${dateString}.${ext}`
    },
    updatePreviewHTML: function () {

      if (this.$refs.previewFormat) {
        this.previewHtml = this.$refs.previewFormat.$el.innerHTML
      } else {
        console.error('this.$refs.previewFormat', this.$refs)
      }
    },
    setPreviewHtml: function () {
      this.updatePreviewHTML()
      const param = {
        app_html: this.cleanedPreviewHtml
      }
      this.submitForm(this.$varuna.endPoints.html, param, 'POST')
    },
    saveDownloadLog: function (pdfBlob, filename) {
      // PDF Download log
      if (this.$firebase.isAuthenticated) {
        this.$firebase.addPdfDownloadLog(
          this.currentFormat.id,
          this.currentFormat.title, {
            formatData: this.formatData,
            basicData: this.basicData
          },
          pdfBlob,
          filename
        )
      }
    },
    downloadPDF: function () {
      const app = this
      this.displayPopup()
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      if (this.$deviceLib.isIE) {
        this.downloadPDFWithForm(true)
      } else {
        this.downloadPDFWithLink()
      }
    },
    saveBackup: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + 'のバックアップ'
      } else {
        this.saveLabel = 'バックアップ'
      }
      this.updatePreviewHTML()
      const app_html = this.cleanedPreviewHtml
      this.$firebase.addBackup(this.saveLabel, 'user', true)
    },
    displayPopup: async function () {
      const app = this
    },
    registYagioffer: async function (userdata) {
      const app = this
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      console.error(this.cardId)
      console.error('*************')
      console.error(this.formatData)
      console.error('*************')
      
      
      app.saveBackup()
    },
    openSCREENSHOT: function () {
      this.updatePreviewHTML()
      const param = {
        app_html: this.cleanedPreviewHtml
      }
      this.submitForm(this.$varuna.endPoints.screenshot + this.createFilename('png'), param, 'POST')
    },
    submitForm: function (url, data, method) {
      const form = document.createElement('form')
      document.body.appendChild(form)
      form.action = url
      form.method = method
      for (const name in data) {
        let input = document.createElement('input')
        input.type = 'hidden'
        input.name = name
        input.value = data[name]
        form.appendChild(input)
      }
      form.submit()
      document.body.removeChild(form)
    },
    hidePreviewDialog: function (e) {
      if (this.previewDialogVisible) {
        this.previewDialogVisible = false
      }
    },
    setPreviewScaleDebounce: function (e) {
      _.debounce(this.setPreviewScale, 1000)
    },
    sendEmailVerification: async function() {
      const app = this
      await this.$firebase.user.sendEmailVerification().then(() => {
        app.$message({
          message: '送信しました。メール内のリンクをクリックしてください',
          type: 'success'
        })
        
      }).catch((error) => {
        app.$message({
          message: '送信失敗しました。',
          type: 'error'
        })
      })
    },
    getFontPaymented: function() {
      console.error("getFontPaymented:" + this.fontPaymented)
      return this.fontPaymented
    }
  },
  watch: {
    'cardId': function () {
      this.currentCardId = this.cardId
      if (this.currentCardIndex < 0) {
        this.goFirstCard()
      }
    },
    previewTabActive: function () {
      this.setPreviewScale()
    }
  },
  beforeMount: function () {
    this.loadCurrentFormat()
    if (this.currentFormat) {
      this.requiredBasicFields = this.currentFormat['requiredBasicFields']
    }
    if (this.cardId) {
      this.currentCardId = this.cardId
    }
    if (!this.$firebase.isAuthenticated) {
      if (this.currentCardId != 'profile' && this.currentCardId != '' && this.currentCardId != 'letterprofile' && this.currentCardId != 'output') {
        // console.error('open-tempdata-dialog：' + this.currentCardId)
        // this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
      }

    } 
    window.addEventListener("beforeunload", this.preventNav)
  },
  beforeDestroy() {
    // Don't forget to clean up event listeners
    window.removeEventListener("beforeunload", this.preventNav)
  },
  created : function(){
    console.log('created')
  },
  mounted: function () {
    if (this.currentCardIndex < 0) {
      this.goFirstCard()
    }
    console.error("mounted:"+this.$firebase.isAuthenticated)
    this.$eventHub.$on('local-format-data-loaded', this.setPreviewHeight)
    this.$eventHub.$on('basic-data-changed', this.updateBasicData)
    this.$eventHub.$on('format-data-changed', this.updateFormatData)
    this.$eventHub.$on('format-otherdata-changed', this.updateFormatOtherData)
    this.$eventHub.$on('backup-loaded-' + RECENT_EDIT_SAVE_KEY, this.setRecentEdit)
    this.$eventHub.$on('save-complete-notify', this.saveNotify)
    this.$eventHub.$on('yagioffer-regist-update', this.registYagioffer)
    // this.$eventHub.$on('send-special-quickemail', this.sendQuickEmail)
    // this.$eventHub.$on('go-card-to', this.goCardTo)
    // this.$eventHub.$on('show-preview', this.showPreview)
    // this.$eventHub.$on('show-preview-4conv', this.showPreview4Conv)
    if (this.preview === false) {
      this.closePreview()
    } else if (this.preview === true) {
      this.showPreview()
    } 
    if (this.currentCardId == 'confirm') {
      // this.setPreviewScale()
      this.showPreviewTest()
    }
    const app = this
    this.$getItem(LAST_SAVE_DATE_SAVE_KEY, function (err, data) {
      if (err) {
        console.error(err)
        return
      }
      app.saveDate = data
      app.updateSaveNotifyMessage()
    })
    // set event listeners and timer
    window.addEventListener('popstate', this.hidePreviewDialog, false)
    window.addEventListener('resize', this.setPreviewScaleDebounce, false)
    this.saveNotifyMessageUpdateTimer = setInterval(this.updateSaveNotifyMessage, 5000)
    this.scrollToCurrentStep()
    console.error("mounted:"+this.$firebase.isAuthenticated)
  },
  destroyed: function () {
    // remove event listeners and timer
    this.$eventHub.$off('local-format-data-loaded', this.setPreviewHeight)
    this.$eventHub.$off('basic-data-changed', this.updateBasicData)
    this.$eventHub.$off('format-data-changed', this.updateFormatData)
    this.$eventHub.$off('format-otherdata-changed', this.updateFormatOtherData)
    this.$eventHub.$off('backup-loaded-' + RECENT_EDIT_SAVE_KEY, this.setRecentEdit)
    this.$eventHub.$off('save-complete-notify', this.saveNotify)
    this.$eventHub.$off('yagioffer-regist-update', this.registYagioffer)
    // this.$eventHub.$off('send-special-quickemail', this.sendQuickEmail)
    // this.$eventHub.$off('go-card-to', this.goCardTo)
    // this.$eventHub.$off('show-preview', this.showPreview)
    // this.$eventHub.$off('get_font_paymented', this.getFontPaymented)
    // this.$eventHub.$off('show-preview-4conv', this.showPreview4Conv)
    window.removeEventListener('popstate', this.hidePreviewDialog, false)
    window.removeEventListener('resize', this.setPreviewScaleDebounce, false)
    clearInterval(this.saveNotifyMessageUpdateTimer)
  }
}
</script>
